"use client"

import Advertisement from "@/components/Advertisement"

export const LISTING_GRID_CLASS =
  "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5"

export const LISTING_AD_TOP_AFTER_ITEMS = 4
export const LISTING_AD_MIDDLE_AFTER_ITEMS = 12

const LISTING_AD_WRAPPER_CLASS = "col-span-full flex justify-center py-1 min-w-0"
const LISTING_AD_IMAGE_CLASS =
  "mx-auto w-full max-w-3xl h-auto max-h-28 sm:max-h-32 md:max-h-40 object-contain rounded-md"

export function ListingInlineAd({ page, position }) {
  return (
    <div className={LISTING_AD_WRAPPER_CLASS}>
      <Advertisement
        page={page}
        position={position}
        wrapperClassName="w-full max-w-3xl"
        className={LISTING_AD_IMAGE_CLASS}
      />
    </div>
  )
}

export function ListingSectionAd({ page, position }) {
  return (
    <Advertisement
      page={page}
      position={position}
      wrapperClassName="mx-auto w-full max-w-3xl py-2 md:py-3"
      className={LISTING_AD_IMAGE_CLASS}
    />
  )
}

export function renderNewsGridWithAds(news, page, renderItem) {
  const items = []

  news.forEach((item, index) => {
    items.push(renderItem(item, index))

    if (index === LISTING_AD_TOP_AFTER_ITEMS - 1) {
      items.push(
        <ListingInlineAd
          key={`listing-ad-top-${page}-${item.id}`}
          page={page}
          position="top"
        />
      )
    }

    if (index === LISTING_AD_MIDDLE_AFTER_ITEMS - 1) {
      items.push(
        <ListingInlineAd
          key={`listing-ad-middle-${page}-${item.id}`}
          page={page}
          position="middle"
        />
      )
    }
  })

  return items
}
